// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.titulo {
    position: fixed;
    right: 0;
    /* z-index: 1000; */
    left: 0;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    top: 0px;
    font-size: 25px;
    width: 600px;
    /* border-radius: 10px; */
    font-style: normal;
    font-stretch: wider;
    font-weight: 700;
    /* background: linear-gradient(150deg, rgba(255, 255, 255, 0.7)0%, rgba(175, 175, 175, 0.7)100%); */
    padding-top: 20px;
    padding-bottom: 20px;
    /* box-shadow: 0px 1px 10px black; */
}`, "",{"version":3,"sources":["webpack://./src/styles/pages/components/Title.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,QAAQ;IACR,mBAAmB;IACnB,OAAO;IACP,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;IACR,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,mGAAmG;IACnG,iBAAiB;IACjB,oBAAoB;IACpB,oCAAoC;AACxC","sourcesContent":[".titulo {\n    position: fixed;\n    right: 0;\n    /* z-index: 1000; */\n    left: 0;\n    text-align: center;\n    margin-left: auto;\n    margin-right: auto;\n    top: 0px;\n    font-size: 25px;\n    width: 600px;\n    /* border-radius: 10px; */\n    font-style: normal;\n    font-stretch: wider;\n    font-weight: 700;\n    /* background: linear-gradient(150deg, rgba(255, 255, 255, 0.7)0%, rgba(175, 175, 175, 0.7)100%); */\n    padding-top: 20px;\n    padding-bottom: 20px;\n    /* box-shadow: 0px 1px 10px black; */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
